var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTk = function SvgTk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1800 900"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "tk_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1-.325H0v.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1-.325.19.263l-.293-.405z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__a",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__a",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__a",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__a",
    transform: "rotate(288)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0h1800v900H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed100",
    d: "M329.376 777.265c-17.934-.15 168.624-99.431 324.77-226.6C858.788 384 1299.54 117.157 1429.115 73.796c13.543-4.532-27.776 23.073-33.14 32.016-138.341 163.74-27.925 472.724 144.973 628.048 51.99 39.763 49.327 41.85 145.707 45.746v9l-1357.28-11.34zm-11.251 18.06S304.962 804.727 305 811.73c.043 7.772 14.766 18.047 14.766 18.047l1338.745 14.765 24.609-16.406-34.453-21.328z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__b",
    transform: "matrix(45 0 0 45 342.957 112.581)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__b",
    transform: "translate(521.205 267.53)scale(37.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__b",
    transform: "matrix(45 0 0 45 135 321.808)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk_svg__b",
    transform: "translate(342.957 652.581)scale(52.5)"
  }))));
};
export default SvgTk;